import { Button } from '#app/components/Buttons/Button.js';
import { Tooltip } from '#app/components/Tooltip/Tooltip.js';
import { type TooltipCompoundProps } from '#app/components/Tooltip/types.js';
import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const TooltipWrapper = ({
  children,
  hideTooltip = false,
  ...props
}: TooltipCompoundProps & { readonly hideTooltip?: boolean }) => (
  <>{hideTooltip ? children : <Tooltip {...props}>{children}</Tooltip>}</>
);

const ButtonWrapper = styled.div`
  max-width: 282px;
  width: 100%;
  & > div {
    display: block;
  }
  & > div,
  & button {
    width: 100%;
  }
`;

export const InquiryButton = styled(Button)<{
  $displayAsDisabled?: boolean;
}>`
  ${({ $displayAsDisabled, theme }) => css`
    transition: all 125ms ease-out;
    transition-property: background-color, color;
    font-weight: ${theme.textStyles.subtitleRegular.fontWeight};
    font-size: ${theme.textStyles.subtitleRegular.fontSize};
    ${$displayAsDisabled &&
    css`
      color: ${theme.colorsV2.gray50};
      background-color: ${theme.colorsV2.gray20};
    `}
  `}
`;

type InquiryButtonContainerProps = {
  readonly children: ReactNode;
  readonly shouldHideTooltip?: boolean;
  readonly tooltipContent?: string;
  readonly width?: number;
};

export const InquiryButtonContainer = ({
  children,
  shouldHideTooltip = false,
  tooltipContent,
  width = 280,
}: InquiryButtonContainerProps) => {
  return (
    <ButtonWrapper>
      {tooltipContent ? (
        <TooltipWrapper
          content={tooltipContent}
          hideReferenceContainerOutlineOnFocus
          hideTooltip={shouldHideTooltip}
          width={width}
        >
          {children}
        </TooltipWrapper>
      ) : (
        children
      )}
    </ButtonWrapper>
  );
};
